import React from 'react';
import { FormattedMessage } from 'react-intl';

export const RESTORE_ATB_SECONDS = 3000;

export const ADD_TO_BUG_SUCCESS_MESSAGE_ID = 'products.pdp.addToBag.addedToBagMsg';
export const OUT_OF_STOCK_ERROR_MESSAGE_ID = 'products.pdp.addToBag.outOfStockError';

export const ADD_TO_WISHLIST_SUCCESS_MESSAGE_ID = 'products.pdp.addToWishlist.addedToWishlistMsg';

export const STATUS_CODES = {
  ADD_PRODUCT_DISABLED: 'ADD_PRODUCT_DISABLED',
  ADD_PRODUCT_SELECT_SIZE: 'ADD_PRODUCT_SELECT_SIZE',
  ADD_PRODUCT_READY: 'ADD_PRODUCT_READY',
  ADDING_PRODUCT: 'ADDING_PRODUCT',
  ADDED_PRODUCT: 'ADDED_PRODUCT',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  ADD_PRODUCT_ERROR: 'ADD_PRODUCT_ERROR',
  SIZE_OUT_OF_STOCK: 'SIZE_OUT_OF_STOCK',
  SIZE_OUT_OF_STOCK_NON_FULL_PRICE: 'SIZE_OUT_OF_STOCK_NON_FULL_PRICE',
  OUT_OF_STOCK_NON_FULL_PRICE: 'OUT_OF_STOCK_NON_FULL_PRICE',
};

export const ATB_STATE = {};
export const getWishlistButtonState = (state, options) => {
  const mergedOptions = {
    isProductInWishlist: false,
    readySelectSizeText: false,
    noIcon: false,
    noText: false,
    ...options,
  };

  const { isProductInWishlist, noIcon, noText, readySelectSizeText } = mergedOptions;

  const hoverText =
    readySelectSizeText || noText
      ? {}
      : {
          hoverText: (
            <FormattedMessage id="products.sizeSelector.pleaseSelectSize" description="Please select a size" />
          ),
          actionClassName: '_is-invalid _is-hover-action-enabled',
        };

  const ADD_TO_WISHLIST_STATE = {
    [STATUS_CODES.ADD_PRODUCT_SELECT_SIZE]: {
      code: STATUS_CODES.ADD_PRODUCT_SELECT_SIZE,
      ariaLabel: 'wishlist.add.label',
      wrapperClass: 'product__add-to-wishlist',
      actionClassName: '_is-invalid',
      icon: noIcon ? '_is-hidden' : `icon-wishlist${isProductInWishlist ? '-filled' : ''}`,
      disabled: isProductInWishlist,
      buttonText: isProductInWishlist ? (
        <FormattedMessage id="wishlist.added.label" />
      ) : (
        !noText && <FormattedMessage id="wishlist.add.label" />
      ),
      errorText: <FormattedMessage id="wishlist.select.label" description="Please select a size to Add to Wishlist" />,
      ...(isProductInWishlist ? {} : hoverText),
    },
    [STATUS_CODES.ADD_PRODUCT_READY]: {
      code: STATUS_CODES.ADD_PRODUCT_READY,
      ariaLabel: 'wishlist.add.label',
      wrapperClass: 'product__add-to-wishlist',
      icon: noIcon ? '_is-hidden' : `icon-wishlist${isProductInWishlist ? '-filled' : ''}`,
      buttonText: isProductInWishlist ? (
        <FormattedMessage id="wishlist.added.label" />
      ) : (
        !noText && <FormattedMessage id="wishlist.add.label" />
      ),
      disabled: isProductInWishlist,
    },
    [STATUS_CODES.ADDING_PRODUCT]: {
      code: STATUS_CODES.ADDING_PRODUCT,
      ariaLabel: 'products.pdp.addToWishlist.addingToWishlist',
      wrapperClass: 'product__add-to-wishlist',
      actionClassName: '_is-adding-to-bag',
      icon: 'icon-loop2',
      buttonText: !noText && <FormattedMessage id="products.pdp.addToWishlist.addingToWishlist" />,
      disabled: true,
    },
    [STATUS_CODES.ADDED_PRODUCT]: {
      code: STATUS_CODES.ADDED_PRODUCT,
      ariaLabel: 'wishlist.added.label',
      wrapperClass: 'product__add-to-wishlist',
      actionClassName: '_is-added-to-bag',
      icon: 'icon-tick-filled',
      buttonText: !noText && <FormattedMessage id="wishlist.added.label" />,
      disabled: true,
    },
  };

  if (state === STATUS_CODES.OUT_OF_STOCK || state === STATUS_CODES.OUT_OF_STOCK_NON_FULL_PRICE) {
    return ADD_TO_WISHLIST_STATE[STATUS_CODES.ADD_PRODUCT_SELECT_SIZE];
  }
  if (state === STATUS_CODES.SIZE_OUT_OF_STOCK || state === STATUS_CODES.SIZE_OUT_OF_STOCK_NON_FULL_PRICE) {
    return ADD_TO_WISHLIST_STATE[STATUS_CODES.ADD_PRODUCT_READY];
  }
  return ADD_TO_WISHLIST_STATE[state];
};

ATB_STATE[STATUS_CODES.ADD_PRODUCT_SELECT_SIZE] = {
  code: STATUS_CODES.ADD_PRODUCT_SELECT_SIZE,
  ariaLabel: 'products.pdp.addToBag.addToBag',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-invalid _is-hover-action-enabled',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addToBag" />,
  hoverText: <FormattedMessage id="products.sizeSelector.pleaseSelectSize" description="Please select a size" />,
  disabled: false,
  errorText: <FormattedMessage id="products.sizeSelector.pleaseSelectSize" description="Please select a size" />,
};

ATB_STATE[STATUS_CODES.ADD_PRODUCT_READY] = {
  code: STATUS_CODES.ADD_PRODUCT_READY,
  ariaLabel: 'products.pdp.addToBag.addToBag',
  wrapperClass: 'product__add-to-bag',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addToBag" />,
  disabled: false,
};

ATB_STATE[STATUS_CODES.ADDING_PRODUCT] = {
  code: STATUS_CODES.ADDING_PRODUCT,
  ariaLabel: 'products.pdp.addToBag.addingToBag',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-adding-to-bag',
  icon: 'icon-loop2',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addingToBag" />,
  disabled: true,
};

ATB_STATE[STATUS_CODES.ADDED_PRODUCT] = {
  code: STATUS_CODES.ADDED_PRODUCT,
  ariaLabel: 'products.pdp.addToBag.addedToBag',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-added-to-bag',
  icon: 'icon-tick-filled',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addedToBag" />,
  disabled: true,
};

ATB_STATE[STATUS_CODES.SIZE_OUT_OF_STOCK] = {
  code: STATUS_CODES.SIZE_OUT_OF_STOCK,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-add-to-bag-error',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.notifymemodal.notifyme" />,
  errorText: <FormattedMessage id="products.details.screen.addToBag.size.weCanNotifyYou" />,
  hoverText: '',
  disabled: false,
};

ATB_STATE[STATUS_CODES.ADD_PRODUCT_ERROR] = {
  code: STATUS_CODES.ADD_PRODUCT_ERROR,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-add-to-bag-error',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addToBag" />,
  disabled: true,
  errorText: <FormattedMessage id="products.pdp.addToBag.outOfStockError" />,
};

ATB_STATE[STATUS_CODES.OUT_OF_STOCK] = {
  code: STATUS_CODES.OUT_OF_STOCK,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.notifymemodal.notifyme" />,
  errorText: <FormattedMessage id="products.notifymemodal.weHaveSoldOut" />,
  hoverText: '',
  disabled: false,
};

ATB_STATE[STATUS_CODES.ADD_PRODUCT_DISABLED] = {
  code: STATUS_CODES.OUT_OF_STOCK,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-invalid',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.pdp.addToBag.addToBag" />,
  hoverText: '',
  disabled: true,
};

ATB_STATE[STATUS_CODES.SIZE_OUT_OF_STOCK_NON_FULL_PRICE] = {
  code: STATUS_CODES.SIZE_OUT_OF_STOCK_NON_FULL_PRICE,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.cta.addToCart" />,
  errorText: <FormattedMessage id="products.pdp.sizeselector.outOfStock" />,
  hoverText: '',
  disabled: true,
};

ATB_STATE[STATUS_CODES.OUT_OF_STOCK_NON_FULL_PRICE] = {
  code: STATUS_CODES.OUT_OF_STOCK_NON_FULL_PRICE,
  ariaLabel: 'products.pdp.addToBag.outOfStockError',
  wrapperClass: 'product__add-to-bag',
  actionClassName: '_is-disabled _is-hover-action-disabled',
  icon: '_is-hidden',
  buttonText: <FormattedMessage id="products.pdp.sizeTileSelector.outOfStock.title" />,
  errorText: <FormattedMessage id="products.productgrid.addToBag.outOfStock" />,
  hoverText: '',
  disabled: true,
};
